export const archiveTypeMap: Record<number, string> = {
  0: 'Promo was deleted',
  1: 'Promo was deleted',
  2: 'SKU removed from promo',
};

export const getArchiveTypeLabel = (archiveType: number): string => {
  return archiveTypeMap[archiveType] || '';
};
